import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
    PAYMENT_MAKE_PAYMENT,
    PAYMENT_STANDING_ORDER,
    PAYMENT_DIRECT_DEBIT,
    PAYMENT_ADD_CASH,
    MORE_ACCOUNT_DETAILS,
    PAYMENT_MANAGE_PAYEES,
} from 'constants/shared/routes';
import Container from 'components/shared/generic/container/presentational/Container';
import Payments from '../presentational/Payments';
import { getTheme } from 'selectors/darkMode';

const PaymentsContainer = () => {
    const navigate = useNavigate();
    const isDarkModeEnabled = useSelector(getTheme) as boolean;

    const handleMakePayment = () => navigate(PAYMENT_MAKE_PAYMENT);
    const handleViewStandingOrders = () => navigate(PAYMENT_STANDING_ORDER);
    const handleManagePayee = () => navigate(PAYMENT_MANAGE_PAYEES);
    const handleViewDirectDebits = () => navigate(PAYMENT_DIRECT_DEBIT);
    const handleAddCash = () => navigate(PAYMENT_ADD_CASH);
    const handleSalary = () => navigate(MORE_ACCOUNT_DETAILS);

    return (
        <Container>
            <Payments
                onMakePaymentClick={handleMakePayment}
                onManagePayeeClick={handleManagePayee}
                onStandingOrdersClick={handleViewStandingOrders}
                onDirectDebitClick={handleViewDirectDebits}
                onAddCashClick={handleAddCash}
                onSalaryClick={handleSalary}
                isDarkModeEnabled={isDarkModeEnabled}
            />
        </Container>
    );
};

export default PaymentsContainer;
